angular.module('App',[
    'jv.AppDetails.Controller',
    'jv.AppList.Controller',
    'jv.SendMessage.Controller'
]);